(function() {

  const RGPDConsent = {
    modal: null,
    overlay: null,
    acceptButton: null,
    cancelButton: null,
    checkboxes: null,
    requiredCheckboxes: null,
    errorMessage: null,
    pendingAction: null,
    isConsentGiven: false,
    
    config: {
      storageKey: 'rgpd_consent_given',
      sessionDuration: 30 * 60 * 1000,
    },

    init: function() {
      const self = this;
      
      this.modal = document.getElementById('rgpd-consent-modal');
      
      if (!this.modal) return;

      this.overlay = this.modal.querySelector('.rgpd-modal__overlay');
      this.acceptButton = document.getElementById('rgpd-accept-button');
      this.cancelButton = document.getElementById('rgpd-cancel-button');
      this.errorMessage = document.getElementById('rgpd-error-message');
      this.checkboxes = this.modal.querySelectorAll('.rgpd-consent__checkbox');
      this.requiredCheckboxes = this.modal.querySelectorAll('.rgpd-consent__checkbox[required]');

      this.checkStoredConsent();
      this.setupEventListeners();
      this.waitForCheckoutButtons();
    },

    checkStoredConsent: function() {
      const storedConsent = sessionStorage.getItem(this.config.storageKey);
      
      if (storedConsent) {
        try {
          const consentData = JSON.parse(storedConsent);
          const now = new Date().getTime();
          
          if (consentData.timestamp && (now - consentData.timestamp) < this.config.sessionDuration) {
            this.isConsentGiven = true;
          } else {
            sessionStorage.removeItem(this.config.storageKey);
          }
        } catch (e) {
          sessionStorage.removeItem(this.config.storageKey);
        }
      }
    },

    setupEventListeners: function() {
      const self = this;

      if (this.acceptButton) {
        this.acceptButton.addEventListener('click', function(e) {
          e.preventDefault();
          self.handleAccept();
        });
      }

      if (this.cancelButton) {
        this.cancelButton.addEventListener('click', function(e) {
          e.preventDefault();
          self.hideModal();
        });
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', function(e) {
          e.preventDefault();
          self.hideModal();
        });
      }

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && self.modal.classList.contains('is-visible')) {
          self.hideModal();
        }
      });

      this.checkboxes.forEach(function(checkbox) {
        checkbox.addEventListener('change', function() {
          self.clearErrors();
        });
      });
    },

    interceptCheckoutButtons: function() {
      const self = this;
      
      this.checkoutClickHandler = function(e) {
        if (self.isConsentGiven) {
          return true;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        self.pendingAction = {
          button: e.currentTarget,
          form: e.currentTarget.closest('form')
        };

        self.showModal();
        return false;
      };
      
      const checkoutButtons = document.querySelectorAll(
        'input[name="checkout"], ' +
        'button[name="checkout"], ' +
        '#mini-cart .ajax-cart__button-submit, ' +
        '.ajax-cart__form-wrapper .ajax-cart__button-submit'
      );
      
      let totalButtons = 0;
      
      checkoutButtons.forEach(function(button) {
        if (button.hasAttribute('data-rgpd-intercepted')) {
          return;
        }
        
        totalButtons++;
        button.setAttribute('data-rgpd-intercepted', 'true');
        button.addEventListener('click', self.checkoutClickHandler, true);
      });
    },
    
    waitForCheckoutButtons: function(callback, maxAttempts) {
      const self = this;
      maxAttempts = maxAttempts || 10;
      let attempts = 0;
      
      function tryIntercept() {
        attempts++;
        
        const buttons = document.querySelectorAll(
          'input[name="checkout"], ' +
          'button[name="checkout"], ' +
          '.ajax-cart__button-submit'
        );
        
        const newButtons = Array.from(buttons).filter(function(btn) {
          return !btn.hasAttribute('data-rgpd-intercepted');
        });
        
        if (newButtons.length > 0) {
          self.interceptCheckoutButtons();
          if (callback) callback();
          return;
        }
        
        if (attempts < maxAttempts) {
          setTimeout(tryIntercept, 200);
        } else {
          if (callback) callback();
        }
      }
      
      tryIntercept();
    },
    
    reinterceptCheckoutButtons: function() {
      const allButtons = document.querySelectorAll('[data-rgpd-intercepted]');
      allButtons.forEach(function(button) {
        button.removeAttribute('data-rgpd-intercepted');
      });
      
      this.interceptCheckoutButtons();
    },

    showModal: function() {
      if (!this.modal) return;
      
      document.body.classList.add('rgpd-modal-open');
      this.modal.style.display = 'flex';
      
      setTimeout(() => {
        this.modal.classList.add('is-visible');
      }, 10);
    },

    hideModal: function() {
      if (!this.modal) return;

      this.modal.classList.remove('is-visible');
      
      setTimeout(() => {
        this.modal.style.display = 'none';
        document.body.classList.remove('rgpd-modal-open');
        this.clearErrors();
      }, 300);

      this.pendingAction = null;
    },

    handleAccept: function() {
      const self = this;

      if (!this.validateCheckboxes()) {
        this.showError();
        return;
      }

      const consents = this.collectConsents();

      this.saveConsentsToCart(consents).then(function() {
        self.storeConsentInSession(consents);
        self.isConsentGiven = true;
        self.hideModal();
        self.executePendingAction();
      }).catch(function(error) {
        alert('Error al guardar los consentimientos. Por favor, inténtalo de nuevo.');
      });
    },

    validateCheckboxes: function() {
      let allChecked = true;

      this.requiredCheckboxes.forEach(function(checkbox) {
        if (!checkbox.checked) {
          allChecked = false;
          checkbox.closest('.rgpd-consent__item').classList.add('has-error');
        }
      });

      return allChecked;
    },

    showError: function() {
      if (this.errorMessage) {
        this.errorMessage.style.display = 'block';
        this.errorMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },

    clearErrors: function() {
      if (this.errorMessage) {
        this.errorMessage.style.display = 'none';
      }

      const errorItems = this.modal.querySelectorAll('.rgpd-consent__item.has-error');
      errorItems.forEach(function(item) {
        item.classList.remove('has-error');
      });
    },

    collectConsents: function() {
      const consents = {
        timestamp: new Date().toISOString(),
        consents: []
      };

      this.checkboxes.forEach(function(checkbox, index) {
        consents.consents.push({
          id: checkbox.id,
          accepted: checkbox.checked,
          required: checkbox.hasAttribute('required')
        });
      });

      return consents;
    },

    saveConsentsToCart: function(consents) {
      const attributes = {
        'rgpd_consent_timestamp': consents.timestamp,
        'rgpd_consent_ip': '',
      };

      consents.consents.forEach(function(consent, index) {
        attributes['rgpd_consent_' + (index + 1)] = consent.accepted ? 'accepted' : 'rejected';
      });

      if (typeof WAU !== 'undefined' && WAU.ThemeCart && WAU.ThemeCart.updateAttributes) {
        return WAU.ThemeCart.updateAttributes(attributes);
      } else {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ attributes: attributes })
        })
        .then(function(response) {
          if (!response.ok) throw new Error('Error al actualizar el carrito');
          return response.json();
        });
      }
    },

    storeConsentInSession: function(consents) {
      const consentData = {
        timestamp: new Date().getTime(),
        consents: consents
      };

      sessionStorage.setItem(this.config.storageKey, JSON.stringify(consentData));
    },

    executePendingAction: function() {
      if (!this.pendingAction) return;

      const action = this.pendingAction;
      this.pendingAction = null;

      setTimeout(function() {
        if (action.form) {
          action.form.submit();
        } else if (action.button && action.button.href) {
          window.location.href = action.button.href;
        }
      }, 500);
    }
  };

  function waitForModal() {
    return new Promise(function(resolve) {
      if (document.getElementById('rgpd-consent-modal')) {
        resolve();
        return;
      }
      
      const observer = new MutationObserver(function(mutations) {
        if (document.getElementById('rgpd-consent-modal')) {
          observer.disconnect();
          resolve();
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      setTimeout(function() {
        observer.disconnect();
        resolve();
      }, 5000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      waitForModal().then(function() {
        RGPDConsent.init();
      });
    });
  } else {
    waitForModal().then(function() {
      RGPDConsent.init();
    });
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(function() {
      if (!RGPDConsent.modal) {
        waitForModal().then(function() {
          RGPDConsent.init();
        });
      }
    }, 500);
  });

  if (typeof Events !== 'undefined') {
    Events.on('cart:ready', function() {
      if (!RGPDConsent.modal) {
        waitForModal().then(function() {
          RGPDConsent.init();
        });
      } else {
        setTimeout(function() {
          RGPDConsent.reinterceptCheckoutButtons();
        }, 100);
      }
    });
  }
  
  function observeCartChanges() {
    const cartContainers = document.querySelectorAll('.js-ajax-cart-content, .cart-wrapper, .ajax-cart__form-wrapper');
    
    cartContainers.forEach(function(container) {
      const observer = new MutationObserver(function(mutations) {
        if (RGPDConsent.modal) {
          setTimeout(function() {
            RGPDConsent.waitForCheckoutButtons();
          }, 100);
        }
      });
      
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    });
  }
  
  setTimeout(function() {
    observeCartChanges();
    
    setTimeout(function() {
      if (RGPDConsent.modal) {
        RGPDConsent.waitForCheckoutButtons();
      }
    }, 2000);
  }, 500);

  window.RGPDConsent = RGPDConsent;

})();

